export class AssocierProfileAEmployee {
    employeeId: string;
    profileId: string;
    selected: boolean;
}